<!--<script src="https://cdn.jsdelivr.net/npm/chartjs-plugin-datalabels@0.7.0"></script> -->
<script>
import { Line } from "vue-chartjs";
// import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";

export default {
  extends: Line,
  // plugins: [ChartJSPluginDatalabels],
  props: ["title", "data", "labels"],
  data() {
    return {};
  },
  mounted() {
    this.load();
  },
  watch: {
    data() {
      this.load();
    },
  },
  methods: {
    load() {
      this.renderChart(
        {
          // plugins: [ChartJSPluginDatalabels],
          labels: this.$props.labels,
          datasets: [
            {
              label: this.$props.title,
              backgroundColor: "transparent",
              borderColor: "rgba(45, 114, 210, 1)",
              data: this.$props.data,
              lineTension: 0,
              datalabels: {
                display: false,
              },
              // datalabels: {
              //   //이 부분이 핵심
              //   display: true,
              //   align: "top",
              //   anchor: "end",
              //   color: "black",
              //   borderWidth: 2,
              //   padding: {
              //     bottom: 0,
              //   },
              // },
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          // plugins: {
          //   datalabels: {
          //     color: "white",
          //     textAlign: "center",
          //     font: {
          //       weight: "bold",
          //       size: 16,
          //     },
          //   },
          // },
          // plugins: {
          //   datalabels: {
          //     color: "black",
          //     anchor: "end",
          //     align: "right",
          //     offset: 10,
          //     font: {
          //       weight: "bold",
          //       size: 15,
          //     },
          //   },
          // },
          // legend: {
          //   display: false,
          // },
        }
      );
    },
  },
};
</script>
